import { useEffect, useState } from 'react'

import { notifyMethod } from '../../../App'
import useRedux from '../../../hooks/useRedux'
import useRouter from '../../../hooks/useRouter'
import { profileDetails } from '../../../redux/user_management/action'
import { USER_TXT } from '../../../routing/pathName.constant'
import { useFormFn } from '../../../shared/antd/ANTDForm'
import configData from '../../../utils/config'
import { childUsers, userWiseRole } from '../../../utils/constant'
import { b64toFile } from '../../../utils/customFunctions'
import {
  entries,
  include,
  isEqual,
  keys,
  length,
  notEqual,
  ternary,
} from '../../../utils/javascript'
import { getItem, setItem } from '../../../utils/localstorage'
import { userValidation } from '../../../utils/validation'
import { userChildrenList } from '../../layout/sidebar.description'
import {
  cityOptions,
  countryData,
  pincodeOptions,
  stateOptions,
} from '../addressData'
import {
  addNewBuildingApi,
  addNewUserApi,
  getUserList,
  getUserProfileApi,
  updateBuildingApi,
  updateUserApi,
  updateUserContentApi,
  userValidationApi,
} from '../user.api'
import {
  addBuildingForm,
  addBuildingInitial,
  addUserForm,
  addUserInitial,
  roleIdByPath,
} from '../user.description'
let timeoutId = setTimeout(() => {}, 1000)

const addUser = ({
  t,
  editInfo,
  setEditInfo,
  handleCancelEdit,
  isBuilding,
  userDetails,
  apiCall,
  addNewBuildData,
}) => {
  const form = useFormFn()
  const authToken = getItem('token')
  const { params, navigate, location } = useRouter()
  const { dispatch } = useRedux()
  const { country } = configData
  const { customer, transporter, admin } = userWiseRole
  const userType = params?.userType
  const formRoleId = roleIdByPath[userType]
  const formValue = isBuilding ? addBuildingForm : addUserForm
  const initialValues = isBuilding ? addBuildingInitial : addUserInitial
  const [userForm, setUserForm] = useState(formValue)
  const [fileList, setFileList] = useState([])
  const [selectUser, setSelectUser] = useState({
    flag: false,
    data: {},
    list: {},
  })
  const [loader, setLoader] = useState(false)
  const [popup, setPopup] = useState({ open: false, message: '' })
  const userData = JSON.parse(getItem('userData'))
  const { roleId } = { ...userData }

  const getEmailList = () => {
    const tempEmailList = [userForm?.emailList?.[0]]
    entries(editInfo?.data)?.forEach(([key, value]) => {
      if (include(key, 'email') && !isEqual(key, 'emailId') && value) {
        tempEmailList.push({
          ...userForm.emailList[0],
          label: 'user_AdditionalEmail',
        })
      }
    })
    setUserForm(preUserForm => ({ ...preUserForm, emailList: tempEmailList }))
  }

  useEffect(() => {
    if (editInfo?.data?.id) {
      let updatedData = {}
      keys(initialValues).forEach(v => {
        updatedData[v] = editInfo?.data?.[v]
      })
      //temporary default country
      if (isEqual(updatedData.country, 'na')) updatedData.country = 'us'
      form.setFieldsValue(updatedData)
      editInfo?.data?.profileUrl &&
        setFileList([{ uid: '1', url: editInfo?.data?.profileUrl }])
      getEmailList()
      setAddressSelectOption(
        updatedData.country,
        updatedData.state,
        updatedData.city,
      )
    } else {
      setUserForm({ ...formValue })
    }
  }, [editInfo])

  const setAddressData = parentUserData => {
    if (length(keys(parentUserData))) {
      let formData = form.getFieldsValue()
      formData.pincode = parentUserData?.pincode
      formData.state = parentUserData?.state
      formData.city = parentUserData?.city
      formData.address = parentUserData?.address
      formData.country = parentUserData?.country
      //temporary default country
      if (isEqual(formData.country, 'na')) formData.country = 'us'
      form.setFieldsValue(formData)
      setAddressSelectOption(formData.country, formData.state, formData.city)
    }
  }

  useEffect(() => {
    if (currentUserDescription?.parent) {
      async function fetchData() {
        const responseData = await getUsers({ page: 1 })
        setSelectUser({
          ...selectUser,
          data: responseData?.list?.[0] || {},
          list: responseData,
        })
        if (include(childUsers, formRoleId)) {
          setAddressData(responseData?.list?.[0])
        }
      }
      if (isEqual(currentUserDescription?.parent?.id, roleId)) {
        setSelectUser(prev => ({ ...prev, data: userData }))
        include(childUsers, formRoleId) && setAddressData(userData)
      } else {
        fetchData()
      }
    }
  }, [])

  const currentUserDescription = userChildrenList.find(item =>
    isEqual(item?.userId, formRoleId),
  )
  const isSelect = isEqual(roleId, admin)

  const setAddressSelectOption = (country, state, city) => {
    const stateList =
      keys(countryData?.[country])?.map(stateKey => ({
        label: stateKey,
        value: stateKey,
      })) || []

    const cityList =
      keys(countryData?.[country]?.[state])?.map(cityKey => ({
        label: cityKey,
        value: cityKey,
      })) || []
    const pincodeList =
      countryData?.[country]?.[state]?.[city]?.map(v => ({
        value: v,
        label: v,
      })) || []
    setUserForm(preUserForm => ({
      ...preUserForm,
      multipleRow1: {
        ...preUserForm?.multipleRow1,
        state: {
          ...preUserForm?.multipleRow1?.state,
          options: stateList,
        },
        city: {
          ...preUserForm?.multipleRow1?.city,
          options: cityList,
        },
      },
      pincode: {
        ...preUserForm?.pincode,
        options: pincodeList,
      },
    }))
  }

  const handleValuesChange = (e, formData) => {
    let tempUserForm = { ...userForm }
    const currentKey = keys(e).at(0)

    if (isEqual(currentKey, 'pincode') && !e?.pincode) {
      formData.city = null
      formData.state = null
      formData.country = null
      tempUserForm.pincode = {
        ...tempUserForm.pincode,
        options: pincodeOptions,
      }
      tempUserForm.multipleRow1 = {
        ...tempUserForm?.multipleRow1,
        city: {
          ...tempUserForm?.multipleRow1?.city,
          options: cityOptions,
        },
        state: {
          ...tempUserForm?.multipleRow1?.state,
          options: stateOptions,
        },
      }
    }
    if (e?.pincode) {
      entries(countryData).some(([countryKey, stateObj]) =>
        entries(stateObj).some(([stateKey, cityObj]) =>
          entries(cityObj).some(([cityKey, pinArr]) => {
            if (!include(pinArr, e.pincode)) return false
            if (notEqual(formData.country, countryKey)) {
              formData.country = countryKey
            }
            if (notEqual(formData.state, stateKey)) {
              formData.state = stateKey
              tempUserForm.multipleRow1 = {
                ...tempUserForm.multipleRow1,
                state: {
                  ...tempUserForm.multipleRow1.state,
                  options: keys(stateObj)?.map(v => ({
                    label: v,
                    value: v,
                  })),
                },
              }
            }
            if (notEqual(formData.city, cityKey)) {
              formData.city = cityKey
              tempUserForm.multipleRow1 = {
                ...tempUserForm.multipleRow1,
                city: {
                  ...tempUserForm.multipleRow1.city,
                  options: keys(cityObj)?.map(v => ({
                    label: v,
                    value: v,
                  })),
                },
              }
            }
            tempUserForm.pincode = {
              ...tempUserForm.pincode,
              options: pinArr?.map(v => ({
                label: v,
                value: v,
              })),
            }
            return true
          }),
        ),
      )
    }
    if (e?.state) {
      entries(countryData).some(([countryKey, stateObj]) =>
        entries(stateObj).some(([stateKey, cityObj]) => {
          if (notEqual(stateKey, e?.state)) return false
          if (notEqual(formData.country, countryKey)) {
            formData.country = countryKey
          }
          formData.state = stateKey
          const stateOpt = keys(stateObj)?.map(v => ({
            label: v,
            value: v,
          }))
          const cityOpt = keys(cityObj)?.map(v => ({
            label: v,
            value: v,
          }))
          formData.city = cityOpt?.at(0)?.value
          const pincodeOpt = cityObj?.[formData.city]?.map(pin => ({
            label: pin,
            value: pin,
          }))
          formData.pincode = pincodeOpt?.at(0)?.value

          tempUserForm.multipleRow1 = {
            ...tempUserForm.multipleRow1,
            state: {
              ...tempUserForm.multipleRow1.state,
              options: stateOpt,
            },
            city: {
              ...tempUserForm.multipleRow1.city,
              options: cityOpt,
            },
          }
          tempUserForm.pincode = {
            ...tempUserForm.pincode,
            options: pincodeOpt,
          }
          return true
        }),
      )
    }
    if (e?.city) {
      entries(countryData).some(([countryKey, stateObj]) =>
        entries(stateObj).some(([stateKey, cityObj]) =>
          entries(cityObj).some(([cityKey, pinArr]) => {
            if (notEqual(cityKey, e?.city)) return false
            if (notEqual(formData.country, countryKey)) {
              formData.country = countryKey
            }
            if (notEqual(formData.state, stateKey)) {
              formData.state = stateKey
              tempUserForm.multipleRow1 = {
                ...tempUserForm.multipleRow1,
                state: {
                  ...tempUserForm.multipleRow1.state,
                  options: keys(stateObj)?.map(v => ({
                    label: v,
                    value: v,
                  })),
                },
              }
            }
            formData.city = cityKey
            tempUserForm.multipleRow1 = {
              ...tempUserForm.multipleRow1,
              city: {
                ...tempUserForm.multipleRow1.city,
                options: keys(cityObj)?.map(v => ({
                  label: v,
                  value: v,
                })),
              },
            }
            const pincodeOpt = pinArr?.map(pin => ({
              label: pin,
              value: pin,
            }))
            formData.pincode = pincodeOpt.at(0)?.value
            tempUserForm.pincode = {
              ...tempUserForm.pincode,
              options: pincodeOpt,
            }
            return true
          }),
        ),
      )
    }
    if (e?.country) {
      entries(countryData).some(([countryKey, stateObj]) => {
        if (notEqual(countryKey, e?.country)) return false
        formData.country = countryKey
        const stateOpt = keys(stateObj)?.map(v => ({
          label: v,
          value: v,
        }))
        formData.state = stateOpt?.at(0)?.value
        const cityOpt = keys(stateObj?.[formData?.state])?.map(v => ({
          label: v,
          value: v,
        }))
        formData.city = cityOpt?.at(0)?.value
        tempUserForm.multipleRow1 = {
          ...tempUserForm.multipleRow1,
          state: {
            ...tempUserForm.multipleRow1.state,
            options: stateOpt,
          },
          city: {
            ...tempUserForm.multipleRow1.city,
            options: cityOpt,
          },
        }
        const pincodeOpt = stateObj?.[formData?.state]?.[formData?.city]?.map(
          pin => ({
            label: pin,
            value: pin,
          }),
        )
        formData.pincode = pincodeOpt?.at(0)?.value
        tempUserForm.pincode = {
          ...tempUserForm.pincode,
          options: pincodeOpt,
        }
        return true
      })
    }

    if (e?.businessName) {
      if (timeoutId) clearTimeout(timeoutId)
      timeoutId = setTimeout(async () => {
        const params = `?type=BUSINESSNAME&country=${country}&value=${e?.businessName}`
        const response = await userValidationApi({ params })
        if (!response?.data?.success) {
          // form.setFields([
          //   { name: 'businessName', errors: [t(response?.error?.errorMsg)] },
          // ])
          setPopup({ open: true, message: response?.error?.errorMsg })
        }
      }, 350)
    }
    setUserForm(tempUserForm)
    form.setFieldsValue(formData)
  }

  const handleAddEmail = () => {
    let formData = form.getFieldsValue()
    const emailErrors = form
      .getFieldsError()
      ?.filter(v => include(v?.name?.[0], 'email'))
    const emailKeys = keys(formData).filter(v => include(v, 'emailId'))
    const emailValues = emailKeys.map(v => formData?.[v])
    emailErrors.forEach(value => {
      if (isEqual(value?.errors?.[0], t('error_SameEmail'))) {
        const duplicateEmails = emailValues.filter(v =>
          isEqual(v, formData?.[value?.name?.[0]]),
        )
        if (length(duplicateEmails) <= 1) {
          form.setFields([{ name: value?.name?.[0], errors: [] }])
        }
      } else if (!formData[value?.name?.[0]]) {
        form.setFields([
          { name: value?.name?.[0], errors: [t('error_InvalidEmail')] },
        ])
      }
    })
    const finalEmailErrors = form
      .getFieldsError()
      ?.filter(v => include(v?.name?.[0], 'email') && length(v?.errors))

    if (!length(finalEmailErrors)) {
      let tempUserForm = { ...userForm }
      tempUserForm.emailList = [
        ...tempUserForm.emailList,
        {
          ...formValue?.emailList?.[0],
          label: 'user_AdditionalEmail',
        },
      ]
      setUserForm({ ...tempUserForm })
    }
  }

  const handleRemoveEmail = e => {
    let formData = form.getFieldsValue()
    const emailKeys = keys(formData).filter(v => include(v, 'emailId'))
    const tempUserForm = { ...userForm }
    tempUserForm.emailList.splice(e, 1)
    emailKeys.forEach((v, i) => {
      if (i >= e) {
        formData[emailKeys[i]] = formData[emailKeys[i + 1]] || ''
      }
    })
    setUserForm(tempUserForm)
    form.setFieldsValue(formData)
  }

  const updateProfile = async () => {
    const profileResponse = await getUserProfileApi({
      id: editInfo?.data?.id,
    })
    if (profileResponse?.data?.data && isEqual(`/profile`, location.pathname)) {
      dispatch(profileDetails(profileResponse?.data?.data))
      setItem('userData', JSON.stringify(profileResponse?.data?.data))
      setLoader(false)
    } else {
      navigate(`${USER_TXT}/${userType}`, {
        state: { renderUserAPI: true },
      })
      setLoader(false)
    }
    notifyMethod.success({ message: 'msg_UserUpdatedSuccessfully' })
    form.setFieldsValue({ ...initialValues })
    editInfo.flag && handleCancelEdit()
  }

  const onFinish = async data => {
    if (editInfo?.data?.id) {
      if (isBuilding) {
        const payload = {
          userId: editInfo?.data?.userId,
          customerId: editInfo?.data?.userId,
          id: editInfo?.data?.id,
          country: editInfo?.data?.country,
          ...data,
        }
        setLoader(true)
        const response = await updateBuildingApi({ payload })
        setLoader(false)
        if (response?.data?.data) {
          apiCall && apiCall({ pageNo: 1 })
          notifyMethod.success({
            message: 'msg_BuildingUpdatedSuccessfully',
          })
          setEditInfo({ flag: false, data: {} })
        }
      } else {
        let payload = {
          authToken,
          userId: editInfo?.data?.id,
          country: editInfo?.data?.country,
        }
        keys(data).forEach(k => {
          if (notEqual(data?.[k], editInfo?.data?.[k])) {
            payload[k] = data?.[k]
          }
        })
        setLoader(true)
        if (notEqual(editInfo?.data?.profileUrl, fileList?.[0]?.url)) {
          let formData1 = new FormData()
          formData1.append('userId', editInfo?.data?.id)
          formData1.append(
            'profilePic',
            length(fileList)
              ? b64toFile(fileList?.[0]?.url.split('base64,')[1], 'image/png')
              : null,
          )

          await updateUserContentApi({
            payload: formData1,
          })
          if (length(keys(payload)) <= 2) {
            await updateProfile()
          }
        } else if (length(keys(payload)) <= 2) {
          // set message to update the data first
        }
        if (length(keys(payload)) > 2) {
          const response = await updateUserApi({
            payload,
          })
          if (response?.data?.data?.success) {
            await updateProfile()
          }
        }
        setLoader(false)
      }
    } else {
      if (isBuilding) {
        const payload = {
          userId: userDetails?.id,
          ...data,
        }
        setLoader(true)
        const response = await addNewBuildingApi({ payload })
        setLoader(false)
        if (response?.data?.data) {
          notifyMethod.success({ message: 'msg_BuildingAddedSuccessfully' })
          setEditInfo({ flag: false, data: {} })
          apiCall && apiCall({ pageNo: 1 })
          addNewBuildData &&
            addNewBuildData({ newBuilding: response?.data?.data?.building })
        }
      } else {
        if (isSelect || selectUser?.data?.id) {
          const userData = getItem('userData')
            ? JSON.parse(getItem('userData'))
            : null
          const payload = {
            ...data,
            // country: 'USA',
            forRoleId: formRoleId,
            forUserId: currentUserDescription?.parent
              ? selectUser?.data?.id
              : userData?.id,
            profilePic: length(fileList)
              ? b64toFile(fileList?.[0]?.url.split('base64,')[1], 'image/png')
              : null,
          }
          let formData = new FormData()
          length(keys(payload)) &&
            entries(payload).forEach(([key, value]) => {
              formData.append(key, value)
            })
          setLoader(true)
          const response = await addNewUserApi({ payload: formData })
          if (response?.data?.data?.success) {
            navigate(`${USER_TXT}/${userType}`)
            setLoader(false)
            // set success or failure message
            notifyMethod.success({ message: 'msg_UserAddedSuccessfully' })
          } else {
            setLoader(false)
          }
        } else {
          notifyMethod.warning({ message: 'msg_SelectUser' })
        }
      }
    }
  }

  const handleSelectClick = async () => {
    setSelectUser({
      ...selectUser,
      list: notEqual(selectUser?.list?.pageNo, 1)
        ? await getUsers({ page: 1 })
        : selectUser?.list,
      flag: true,
    })
  }

  const handleSelectCancel = () => {
    setSelectUser({ ...selectUser, flag: false })
  }

  const getUsers = async ({ page }) => {
    const response = await getUserList({
      params: `${page}?roleId=${currentUserDescription?.parent?.id}`,
    })
    return await response?.data
  }

  const handleTableChange = async pagination => {
    const { current } = pagination
    setSelectUser({ ...selectUser, list: await getUsers({ page: current }) })
  }

  const onSelectUser = data => {
    if (length(data)) {
      setSelectUser({ ...selectUser, data: data?.[0], flag: false })
    } else {
      notifyMethod.warning({ message: 'msg_SelectUser' })
    }
  }

  const handleSameAsParent = () => {
    const parentUser = selectUser.data
    setAddressData(parentUser)
  }

  const handleSameAsCustomer = () => {
    const details = { ...userDetails }
    if (details && isEqual(details?.roleId, customer)) {
      let tempForm = { ...userForm }
      const dataList = [
        'pincode',
        'state',
        'city',
        'country',
        'address',
        'emailId',
        'emailId1',
        'emailId2',
        'emailId3',
        'emailId4',
        'emailId5',
        'emailId6',
        'emailId7',
        'emailId8',
        'emailId9',
        'emailId10',
        'phoneNumber',
      ]
      let data = { name: details?.businessName }
      const tempEmailList = ternary(
        tempForm?.emailList?.[0],
        [tempForm?.emailList?.[0]],
        [],
      )
      dataList.forEach(value => {
        data[value] = details?.[value]
        if (
          include(value, 'email') &&
          details?.[value] &&
          notEqual(value, 'emailId')
        ) {
          tempEmailList.push({
            ...tempForm?.emailList?.[0],
            label: 'user_AdditionalEmail',
          })
        }
      })
      tempForm.emailList = tempEmailList
      tempForm.pincode = {
        ...tempForm.pincode,
        options: pincodeOptions,
      }
      tempForm.multipleRow1 = {
        ...tempForm?.multipleRow1,
        city: {
          ...tempForm?.multipleRow1?.city,
          options: cityOptions,
        },
        state: {
          ...tempForm?.multipleRow1?.state,
          options: stateOptions,
        },
      }
      setUserForm(tempForm)

      form.setFieldsValue(data)
    }
  }

  const handleClosePopup = () => {
    setPopup({ open: false, message: '' })
  }

  let userNewForm = { ...userForm }
  const nonMandatoryKey = include(
    [customer, transporter],
    currentUserDescription?.userId,
  )
  entries(userForm).forEach(([key, value]) => {
    if (include(['multipleRow1'], key)) {
      entries(value).forEach(([k, v]) => {
        userNewForm[key][k] = {
          ...v,
          rules: userValidation({ type: k, form }),
        }
      })
    } else if (isEqual(key, 'emailList')) {
      value[0].rules = userValidation({
        type: 'emailId',
        form,
      })
      const newList = value.map((v, i) =>
        notEqual(i, 0) ? { ...v, rules: value?.[0]?.rules } : { ...v },
      )
      userNewForm[key] = newList
    } else {
      userNewForm[key] = {
        ...value,
        rules: userValidation({ type: key, form, nonMandatoryKey }),
      }
    }
  })

  return {
    form,
    userForm,
    handleValuesChange,
    onFinish,
    handleAddEmail,
    handleRemoveEmail,
    fileList,
    setFileList,
    currentUserDescription: currentUserDescription || null,
    isSelect,
    handleSelectClick,
    selectUser,
    handleSelectCancel,
    handleTableChange,
    onSelectUser,
    formRoleId,
    handleSameAsParent,
    loader,
    handleSameAsCustomer,
    popup,
    handleClosePopup,
    userNewForm,
  }
}

export default addUser
